/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit BillingDue/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import Content from './Content/index'
import No from './No/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function BillingDue({
  children,
  viewPath = "/DesignSystem/CheckIn/Confirmation/Content/CheckInCriteria/Content/BillingDue"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let checkInAlertsCriteriaHasBillingPastDueValueData = fromData.useDataValue({ viewPath,
context: 'check_in',
path: 'alerts.criteria.has_billing_past_due',
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: Boolean(checkInAlertsCriteriaHasBillingPastDueValueData),
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Content'}>
<Content
  viewPath={`${viewPath}/Content`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}